import { styled } from "@mui/material/styles";
import { Box, Paper, TableContainer } from "@mui/material";

const jakartaRootSx = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  "& .MuiTypography-root, & .MuiButton-root, & .MuiInputBase-root, & .MuiInputLabel-root, & .MuiMenuItem-root, & .MuiTableCell-root, & .MuiChip-label, & .MuiFormLabel-root, & .MuiSelect-select":
    {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
    },
  "& .MuiTableBody-root .MuiTableRow-root.MuiTableRow-hover:hover": {
    backgroundColor: "#ECF1F7",
  },
};

export const PageContainer = styled(Box)(({ theme }) => ({
  ...jakartaRootSx,
  padding: theme.spacing(4),
  minHeight: "100vh",
  background: "transparent",
  backgroundColor: "transparent",
}));

export const CardContainer = styled(Paper)(({ theme }) => ({
  ...jakartaRootSx,
  display: "flex",
  flexDirection: "column",
  padding: "20px",
  width: "calc(100% - 10px)",
  maxWidth: "calc(100% - 10px)",
  minWidth: 0,
  borderRadius: "12px",
  background: "transparent",
  backgroundColor: "transparent",
  margin: "0 auto",
  boxSizing: "border-box",
}));

export const TitleWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));

export const FiltersContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  columnGap: theme.spacing(1),
  rowGap: theme.spacing(2),
  flexWrap: "wrap",
  marginBottom: theme.spacing(3),
}));

export const TabsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  flexWrap: "wrap",
  borderRadius: "12px",
  border: "1px solid var(--Secondary-Global-Secondary-50, #ECF1F7)",
  background: "#FFFFFF",
  backgroundColor: "#FFFFFF",
  marginTop: "-10px",
  marginBottom: theme.spacing(2),
  paddingRight: theme.spacing(1.5),

  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: 4,
  },
  "& .MuiTabs-indicatorSpan": {
    width: "30%",
    borderRadius: "2px",
    backgroundColor: "#15202A",
  },
}));

export const TableContainerStyled = styled(TableContainer)(({ theme }) => ({
  borderRadius: "12px",
  border: `1px solid ${theme.palette.divider}`,
  overflowX: "auto",
  overflowY: "hidden",
  background: "#FFFFFF",
  backgroundColor: "#FFFFFF",
  "& .MuiTableCell-root": {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
  },
}));

export const EmptyState = styled(Box)(({ theme }) => ({
  height: 240,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
}));

export const FooterContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1, 2),
  borderRadius: theme.shape.borderRadius,
  width: "fit-content",
}));
